import { formatDate } from 'core/utils/date'

export function formatScheduledAt(
  appointmentDate: string,
  appointmentTime: string,
  facilityTimezone?: string
) {
  const timezone = facilityTimezone?.replace(/[-_]/g, ' ')
  return `${formatDate(
    new Date(appointmentDate as string),
    'EEEE, MMM d yyyy'
  )} @ ${appointmentTime}${timezone ? ` (${timezone})` : ''}`
}

export function formatNewSchedule(
  appointmentDate: string | null,
  appointmentTime: string | null,
  facilityTimezone?: string
): string | null {
  if (!appointmentDate || !appointmentTime) {
    return null
  }
  return `New schedule: ${formatScheduledAt(appointmentDate, appointmentTime, facilityTimezone)}`
}
